<template>
  <div class="water-quality">
    <section class="equ-head">
      <div class="equipment">
        <span class="title_bg">水质监控</span>
        <div class="equip-status">
          <span>{{ sensorData.name }}</span>
          <!-- <div :class="{'outline':sensorData.powerStatus==0}">(
            <img
              class="equip-logo"
              :src="require('../../assets/images/Electric'+sensorData.powerStatus+'.png')"
            >
            {{
              sensorData.powerStatus!==0?"在线":"离线"
            }}
            )
          </div> -->
          <div
            :class="{ outline: sensorData.powerStatus == 0 }"
            v-if="sensorData.powerStatus == 0"
          >
            (
            <img
              class="equip-logo"
              :src="require('../../assets/images/Electric0.png')"
            />
            {{ "离线" }}
            )
            <span style="margin-left: 16px;">最后更新：{{timeSplit(sensorData.dateTime)}}</span>
          </div>
          <div
            :class="{ outline: sensorData.powerStatus == 0 }"
            v-if="sensorData.powerStatus == 1"
          >
            (
            <img
              class="equip-logo"
              :src="require('../../assets/images/Electric1.png')"
            />
            {{ "在线" }}
            )
          </div>
          <div
            :class="{ outline: sensorData.powerStatus == 0 }"
            v-if="sensorData.powerStatus == 2"
          >
            (
            <img
              class="equip-logo"
              :src="require('../../assets/images/Electric2.png')"
            />
            {{ "电池供电" }}
            )
          </div>
        </div>
      </div>
      <div
        class="warm"
        v-if="sensorData.powerStatus == 1 && sensorData.alarmMessageList.length && second == 0"
      >
        <i class="icon icon-icon_ann"></i>
        <span v-for="(m, num) in sensorData.alarmMessageList" :key="num">
          {{ m }}&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <i
          ref="input"
          id="Alarm"
          @click="clearAlame"
          class="icon icon-pop_icon_close"
        ></i>
      </div>
      <div class="setting" v-if="sensorData.id != '636089367965017276'">
        <i @click="toSetting" class="icon icon-icon_set"></i>
      </div>
    </section>
    <!-- list -->
    <section class="equ-content" v-if="sensorData.id != '636089367965017276'">
      <div
        class="equipments"
        v-for="item in sensorData.sensors"
        :key="item.id"
        :class="sensorData.powerStatus === 1 ? '' : 'offline'"
      >
        <!--   @click="goWaterParamer(item)" -->
        <span
          v-if="item.limitCtrlTag"
          class="iconfont associate"
          :class="'associate' + (item.limitCtrlTag % 7)"
          >&#xe603;</span
        >
        <i
          class="icon parame"
          @click="goWaterParamer(item)"
          :class="
            sensorData.powerStatus === 1
              ? [list[item.measuredType]]
              : [listoff[item.measuredType]]
          "
        ></i>
        <div class="params-wrap">
          <div class="params-desc" @click="goWaterParamer(item)">
            <span class="name">{{ item.name }}</span>
            <div>
              <span :class="getClass(item)" class="value">{{windTran(item.measuredType, item.currentValue)}}</span>
              <span>{{ item.unitTitle }}</span>
            </div>
          </div>
          <div @click="showBox(item)">
            <div class="gradient"></div>
            <p class="parame-value">
              <span>{{ item.minLimit }}</span>
              <span>{{ item.lowerLimit }}</span>
              <span>{{ item.upperLimit }}</span>
              <span>{{ item.maxLimit }}</span>
            </p>
          </div>
          <base-dialog
            :dynamicClass="dynamicClass"
            :titleName="titleName"
            :showDialog="showDialog"
            :dialogWidth="dialogWidth"
            @changeShow="changeShow"
          >
            <section class="wrapLimit">
              <div>
                <span>下限：</span>
                <el-input class="input-name" v-model="lowerLimit">
                  <i slot="suffix" class="el-input__icon">{{ unitTitles }}</i>
                </el-input>
              </div>
              <div>
                <span>上限：</span>
                <el-input class="input-name" v-model="upperLimit">
                  <i slot="suffix" class="el-input__icon">{{ unitTitles }}</i>
                </el-input>
              </div>
            </section>
            <div class="operation">
              <span @click="handleCancel">取消</span>
              <span @click="handleSave">保存</span>
            </div>
          </base-dialog>
        </div>
      </div>
    </section>
    <div class="demo equ-content" v-if="sensorData.id == '636089367965017276'">
      <div class="item" v-for="item of demos" :key="item.id">
        <i class="icon parame" :class="item.icon"></i>
        <div class="params-wrap">
          <div class="params-desc">
            <span class="name">{{ item.name }}</span>
            <div>
              <span class="value">{{ item.currentValue }}</span>
              <span>{{ item.unitTitle }}</span>
            </div>
          </div>
          <div>
            <div class="gradient"></div>
            <p class="parame-value">
              <span>{{ item.minLimit }}</span>
              <span>{{ item.lowerLimit }}</span>
              <span>{{ item.upperLimit }}</span>
              <span>{{ item.maxLimit }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseDialog from '@/components/v2/BaseDialog.vue'
import parameterV2 from '../../store/modules/parameterV2'
import equipmentV2 from '../../store/modules/equipmentV2'
import mixins from '@/assets/js/mixins.js'
import { mapActions } from 'vuex'
export default {
  name: 'WaterQuality',
  mixins: [mixins],
  components: {
    BaseDialog
  },
  props: {
    sensorData: {
      require: true
    }
  },
  data () {
    return {
      dynamicClass: 'limitEdit',
      showDialog: false,
      titleName: '',
      dialogWidth: '412px',
      lowerLimit: '',
      upperLimit: '',
      maxLimit: '',
      minLimit: '',
      id: '',
      unitTitles: '',
      clearSecond: 1800, // 清除警报30分钟
      second: 0, // 清除警报
      list: {
        1: 'icon-icon_rongjieyang',
        3: 'icon-icon_ph',
        2: 'icon-icon_temperature',
        4: 'icon-icon_yanghuadianhuanyuan',
        12: 'icon-icon_yanbaohedu',
        7: 'icon-icon_daqiya',
        9: 'icon-icon_shidu',
        10: 'icon-icon_co2',
        11: 'icon-icon_guangzhao',
        8: 'icon-icon_temperature',
        25: 'icon-icon_shidu',
        24: 'icon-icon_temperature',
        17: 'icon-fengsu',
        16: 'icon-fengxiang',
        23: 'icon-nh3'
      },
      listoff: {
        1: 'icon-icon_rongjieyang_off',
        3: 'icon-icon_ph_off',
        2: 'icon-icon_temperature_off',
        4: 'icon-icon_yanghuadianhuanyuan_off',
        12: 'icon-icon_yanbaohedu_off',
        7: 'icon-icon_daqiya_off',
        9: 'icon-icon_shidu_off',
        10: 'icon-icon_co2_off',
        11: 'icon-icon_guangzhao_off',
        8: 'icon-icon_temperature_off',
        25: 'icon-icon_shidu_off',
        24: 'icon-icon_temperature_off',
        17: 'icon-fengsu_off',
        16: 'icon-fengxiang_off',
        23: 'icon-nh3_off'
      },
      demos: [
        {
          id: 1,
          name: '大气压',
          unitTitle: 'KPA',
          currentValue: 1.01,
          icon: 'icon-icon_daqiya',
          minLimit: 0,
          lowerLimit: 0.5,
          upperLimit: 2,
          maxLimit: 3
        },
        {
          id: 2,
          name: '湿度',
          unitTitle: '%',
          currentValue: 44.5,
          icon: 'icon-icon_shidu',
          minLimit: 0,
          lowerLimit: 30,
          upperLimit: 60,
          maxLimit: 100
        },
        {
          id: 3,
          name: '二氧化碳',
          unitTitle: 'PPM',
          currentValue: 450,
          icon: 'icon-icon_co2',
          minLimit: 0,
          lowerLimit: 300,
          upperLimit: 1200,
          maxLimit: 3000
        },
        {
          id: 4,
          name: '光照',
          unitTitle: 'LUX',
          currentValue: 20,
          icon: 'icon-icon_guangzhao',
          minLimit: 0,
          lowerLimit: 10,
          upperLimit: 300,
          maxLimit: 500
        },
        {
          id: 5,
          name: '溶解氧',
          unitTitle: 'mg/l',
          currentValue: 8.39,
          icon: 'icon-icon_rongjieyang',
          minLimit: 0,
          lowerLimit: 3,
          upperLimit: 17,
          maxLimit: 20
        },
        {
          id: 6,
          name: '氧饱和度',
          unitTitle: '%',
          currentValue: 101,
          icon: 'icon-icon_yanbaohedu',
          minLimit: 0,
          lowerLimit: 80,
          upperLimit: 120,
          maxLimit: 160
        },
        {
          id: 7,
          name: '水温',
          unitTitle: '℃',
          currentValue: 24.2,
          icon: 'icon-icon_temperature',
          minLimit: 0,
          lowerLimit: 20,
          upperLimit: 32,
          maxLimit: 35
        },
        {
          id: 8,
          name: '温度',
          unitTitle: '℃',
          currentValue: 25.2,
          icon: 'icon-icon_temperature',
          minLimit: 0,
          lowerLimit: 10,
          upperLimit: 30,
          maxLimit: 50
        },
        {
          id: 9,
          name: 'PH值',
          unitTitle: '',
          currentValue: 7.42,
          icon: 'icon-icon_ph',
          minLimit: 0,
          lowerLimit: 6.5,
          upperLimit: 8.5,
          maxLimit: 14
        },
        {
          id: 10,
          name: '氨氮',
          unitTitle: 'mg/l',
          currentValue: 0.023,
          icon: 'icon-icon_rongjieyang',
          minLimit: 0,
          lowerLimit: 0,
          upperLimit: 2,
          maxLimit: 10
        }
      ]
    }
  },
  watch: {},
  mounted () {
    console.log(this.sensorData)
  },
  computed: {
    getClass () {
      return function (data) {
        if (data.currentValue < data.lowerLimit) {
          return 'red'
        } else if (data.currentValue > data.upperLimit) {
          return 'orange'
        }
      }
    }
  },
  methods: {
    ...mapActions(equipmentV2, ['getEquipmentsData']),
    ...mapActions(parameterV2, ['updatelimitData']),
    // 时间过滤
    timeSplit (value) {
      return value.replace('T', ' ')
    },
    // 风向转换
    windTran (type, title) {
      if (type === 16) {
        let result = ''
        switch (title) {
          case 0:
            result = '北风'
            break
          case 45:
            result = '东北风'
            break
          case 90:
            result = '东风'
            break
          case 135:
            result = '东南风'
            break
          case 180:
            result = '南风'
            break
          case 225:
            result = '西南风'
            break
          case 270:
            result = '西风'
            break
          case 315:
            result = '西北风'
            break
          default:
            result = title
        }
        return result
      } else {
        return title
      }
    },
    // 弹窗获取数据
    async showBox (item) {
      this.showDialog = true
      this.lowerLimit = item.lowerLimit
      this.upperLimit = item.upperLimit
      this.titleName = item.name
      this.unitTitles = item.unitTitle
      this.id = item.id
      this.maxLimit = item.maxLimit
      this.minLimit = item.minLimit
    },
    changeShow () {
      this.showDialog = false
    },
    handleCancel () {
      this.showDialog = false
    },
    // 保存
    async handleSave () {
      if (!this.lowerLimit || !this.upperLimit) {
        this.$Alert.info({
          content: '下限和上限均不能为空',
          duration: 3000,
          status: 'error'
        })
        return
      }
      if (Number(this.lowerLimit) > Number(this.upperLimit)) {
        this.$Alert.info({
          content: '下限不能大于上限',
          duration: 3000,
          status: 'error'
        })
        return
      }
      if (Number(this.lowerLimit) < Number(this.minLimit)) {
        this.$Alert.info({
          content: '下限不能小于它的最小值',
          duration: 3000,
          status: 'error'
        })
        return
      }
      if (Number(this.upperLimit) > Number(this.maxLimit)) {
        this.$Alert.info({
          content: '上限不能大于它的最大值',
          duration: 3000,
          status: 'error'
        })
        return
      }
      if (Number(this.lowerLimit) < 0 || Number(this.upperLimit) < 0) {
        this.$Alert.info({
          content: '下限和上限均不能为负数',
          duration: 3000,
          status: 'error'
        })
        return
      }
      let limitObj = [
        {
          id: this.id,
          lowerLimit: this.lowerLimit,
          upperLimit: this.upperLimit
        }
      ]
      console.log(limitObj)

      try {
        await this.updatelimitData(limitObj)
        this.$Alert.info({
          content: '保存成功',
          duration: 1000,
          status: 'success'
        })
        this.showDialog = false
        this.updateData()
      } catch (err) {
        console.log(err.response)
        this.$Alert.info({
          content: '保存失败',
          duration: 1000,
          status: 'error'
        })
      }
    },
    updateData () {
      let obj = JSON.parse(localStorage.getItem('currentBasic'))
      this.getEquipmentData(obj, false)
        .then(() => {})
        .catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 3000,
            status: 'error'
          })
        })
    },
    // 进入水质参数
    goWaterParamer (item) {
      this.$router.push({
        name: 'waterParameter',
        query: {
          paraName: item.name,
          iotName: item.iotName,
          equName: this.sensorData.name,
          equId: this.sensorData.id
          // list: JSON.stringify(this.sensorData.sensors)
        }
      })
    },
    toSetting () {
      this.$router.push({
        name: 'autoControl',
        query: {
          equName: this.sensorData.name,
          equId: this.sensorData.id
        }
      })
    },
    // 清除警报 30秒
    clearAlame () {
      this.second = this.clearSecond
      let timer = setInterval(() => {
        --this.second
        if (this.second <= 0) {
          this.second = 0
          clearInterval(timer)
        }
      }, 1000)
      // 清除警报声音
      this.$emit('clearAlame')
    }
  }
}
</script>
<style lang="scss">
.icon-icon_co2,
.icon-icon_co2_off,.icon-icon_daqiya_off,.icon-icon_daqiya,
.icon-icon_guangzhao_off,.icon-icon_guangzhao,.icon-icon_ph_off,.icon-icon_ph,
.icon-icon_rongjieyang_off,.icon-icon_rongjieyang,.icon-icon_shidu_off,.icon-icon_shidu,
.icon-icon_temperature_off,.icon-icon_temperature,.icon-icon_yanbaohedu_off,.icon-icon_yanbaohedu,
.icon-icon_yanghuadianhuanyuan_off,.icon-icon_yanghuadianhuanyuan,
.icon-fengsu_off,.icon-fengsu,.icon-fengxiang_off,.icon-fengxiang,
.icon-nh3_off,.icon-nh3
{
  transform: scale(1.12);
}
@media screen and (max-width: 1400px) {
  .icon-icon_co2,
  .icon-icon_co2_off,.icon-icon_daqiya_off,.icon-icon_daqiya,
  .icon-icon_guangzhao_off,.icon-icon_guangzhao,.icon-icon_ph_off,.icon-icon_ph,.icon-icon_shidu_off,.icon-icon_shidu,
  .icon-icon_yanbaohedu_off,.icon-icon_yanbaohedu,
  .icon-icon_yanghuadianhuanyuan_off,.icon-icon_yanghuadianhuanyuan,
  .icon-fengsu_off,.icon-fengsu,.icon-fengxiang_off,.icon-fengxiang,
  .icon-icon_rongjieyang_off,.icon-icon_rongjieyang,
  .icon-icon_temperature_off,.icon-icon_temperature,
  .icon-nh3_off,.icon-nh3
  {
    transform: scale(0.8);
  }
  .equipments{
    padding:0 0.1rem!important;
  }

}

.water-quality {
  margin-top: 0.2rem;
  .equ-head {
    position: relative;
    margin: 0 0.25rem;
    border-bottom: 1px solid #148eff;
    line-height: 0.44rem;
    height: 0.45rem;
    text-align: center;
    .title_bg {
      display: inline-block;
      width: 1.45rem;
      height: 0.45rem;
      margin-right: 0.1rem;
      padding-right: 0.06rem;
      font-size: 0.18rem;
      color: #fefefe;
      background: url("../../assets/images/title_bg_2.png") no-repeat;
      background-size: 100% 100%;
    }
    .equipment {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-self: center;
    }
    .equip-status {
      display: flex;
      align-items: center;
      font-size: 0.16rem;
      span {
        margin-right: 0.08rem;
      }
      .outline {
        color: #707a97;
      }
    }
    .warm {
      display: inline-block;
      padding: 0 0.2rem;
      border-radius: 4px;
      line-height: 0.3rem;
      height: 0.3rem;
      background: #562a31;
      .icon-icon_ann {
        margin-right: 0.15rem;
      }
      .icon-pop_icon_close {
        // margin-left: 5px;
        cursor: pointer;
      }
    }
    .setting {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      position: absolute;
      right: 0;
      top: 0;
      span {
        font-size: 0.14rem;
      }
      .icon-icon_set {
        cursor: pointer;
      }
    }
  }
  .equ-content {
    padding: 0 0.25rem;
    display: flex;
    flex-wrap: wrap;
    .offline {
      color: #707a97 !important;
    }
    .associate {
      font-size: 0.38rem;
      position: absolute;
      right: 0.26rem;
      top: -0.21rem;
    }
    .associate0 {
      color: #2ed7e3;
    }
    .associate1 {
      color: #e3822e;
    }
    .associate2 {
      color: #e0e32e;
    }
    .associate3 {
      color: #2ee35d;
    }
    .associate4 {
      color: #2ee3a0;
    }
    .associate5 {
      color: #884cca;
    }
    .associate6 {
      color: #3c7bd9;
    }
    > div {
      position: relative;
      padding: 0 0.22rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 4rem;
      height: 1.58rem;
      margin-right: 0.64rem;
      margin-top: 0.2rem;
      background: url("../../assets/images/shuizhicanshu_kuang.png") no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .params-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      /* margin-left: 40px; */
    }
    .params-desc {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      font-size: 0.18rem;
      color: white;
      .name {
        margin-right: 0.15rem;
        font-size: 0.22rem;
        color: #00c6ff;
      }
      .value {
        margin-right: 0.03rem;
        font-size: 0.44rem;
        color: #00d53c;
      }
      .red {
        color: #f52525;
      }
      .orange {
        color: #ff9600;
      }
    }
    .gradient {
      width: 2.32rem;
      height: 0.24rem;
      margin-top: 0.1rem;
      background: linear-gradient(
        90deg,
        rgba(120, 16, 21, 1),
        rgba(32, 108, 35, 1),
        rgba(111, 72, 21, 1)
      );
      border-radius: 0.12rem;
    }
    .parame-value {
      display: flex;
      justify-content: space-between;
      padding: 0.05rem 0.05rem 0;
      span {
        font-size: 0.14rem;
      }
    }
    .offline {
      > div,
      .params-wrap,
      .params-desc,
      .params-desc,
      .name,
      .value {
        color: gray !important;
      }
      .gradient {
        background: linear-gradient(90deg, #635c5d, #a5ada6, #42403d);
      }
    }
    .icon-icon_yanbaohedu,
    .icon-icon_yanbaohedu_off {
      zoom: 0.8 !important;
    }
  }
  // @media screen and (max-width: 1400px) {
  //   .icon {
  //     transform: scale(0.6);
  //   }
  //   .icon-icon_set {
  //     transform: scale(0.8);
  //   }
  //   .equ-head {
  //     height: 0.36rem;
  //     line-height: 0.36rem;
  //     .title_bg {
  //       display: inline-block;
  //       width: 1.2rem;
  //       height: 0.36rem;
  //       margin-right: 0.1rem;
  //       padding-right: 0.06rem;
  //       font-size: 0.16rem;
  //       color: #fefefe;
  //       background: url("../../assets/images/title_bg_2.png") no-repeat;
  //       background-size: 100% 100%;
  //     }
  //     .equip-status {
  //       font-size: 0.14rem;
  //       img {
  //         height: 0.24rem;
  //       }
  //     }
  //     .warm {
  //       display: inline-block;
  //       padding: 0 0.2rem;
  //       border-radius: 0.04rem;
  //       line-height: 0.26rem;
  //       height: 0.26rem;
  //       background: #562a31;
  //       .icon-icon_ann {
  //         margin-right: 0.15rem;
  //       }
  //       .icon-pop_icon_close {
  //         // margin-left: 5px;
  //         cursor: pointer;
  //       }
  //     }
  //   }
  //   .equ-content {
  //     .associate {
  //       font-size: 0.3rem;
  //       position: absolute;
  //       right: 0.26rem;
  //       top: -0.18rem;
  //     }
  //     > div {
  //       width: 2.76rem;
  //       height: 1.11rem;
  //       margin-right: 0.35rem;
  //       padding: 0 0.15rem;
  //     }
  //     .params-wrap {
  //       margin-left: 0.15rem;
  //     }
  //     .params-desc {
  //       .name {
  //         margin-right: 0.05rem;
  //         font-size: 0.14rem;
  //         color: #00c6ff;
  //       }
  //       .value {
  //         margin-right: 0.03rem;
  //         font-size: 0.3rem;
  //         color: #00d53c;
  //       }

  //       .red {
  //         color: #f52525;
  //       }
  //       .orange {
  //         color: #ff9600;
  //       }
  //     }
  //     .gradient {
  //       width: 1.65rem;
  //     }
  //     .parame-value {
  //       font-size: 0.12rem;
  //     }
  //   }
  // }
  // @media screen and (max-width: 1000px) {
  //   .icon {
  //     transform: scale(0.5);
  //   }
  //   .icon-icon_set {
  //     transform: scale(0.7);
  //   }
  //   .equ-head {
  //     height: 0.36rem;
  //     line-height: 0.36rem;
  //     .title_bg {
  //       display: inline-block;
  //       width: 1.2rem;
  //       height: 0.36rem;
  //       margin-right: 0.1rem;
  //       padding-right: 0.06rem;
  //       font-size: 0.16rem;
  //       color: #fefefe;
  //       background: url("../../assets/images/title_bg_2.png") no-repeat;
  //       background-size: 100% 100%;
  //     }
  //     .equip-status {
  //       font-size: 0.14rem;
  //       img {
  //         height: 0.24rem;
  //       }
  //     }
  //     .warm {
  //       display: inline-block;
  //       padding: 0 0.2rem;
  //       border-radius: 4px;
  //       line-height: 0.26rem;
  //       height: 0.26rem;
  //       background: #562a31;
  //       .icon-icon_ann {
  //         margin-right: 0.15rem;
  //       }
  //       .icon-pop_icon_close {
  //         // margin-left: 5px;
  //         cursor: pointer;
  //       }
  //     }
  //   }
  //   .equ-content {
  //     .associate {
  //       font-size: 0.3rem;
  //       position: absolute;
  //       right: 0.26rem;
  //       top: -0.18rem;
  //     }
  //     > div {
  //       width: 2.66rem;
  //       height: 1.11rem;
  //       margin-right: 0.1rem;
  //       padding: 0px;
  //     }
  //     .params-wrap {
  //       // margin-left: 15px;
  //     }
  //     .params-desc {
  //       .name {
  //         // margin-right: 5px;
  //         font-size: 0.14rem;
  //         color: #00c6ff;
  //       }
  //       .value {
  //         margin-right: 0.03rem;
  //         font-size: 0.3rem;
  //         color: #00d53c;
  //       }

  //       .red {
  //         color: #f52525;
  //       }
  //       .orange {
  //         color: #ff9600;
  //       }
  //     }
  //     .gradient {
  //       width: 1.65rem;
  //     }
  //     .parame-value {
  //       font-size: 0.12rem;
  //     }
  //   }
  // }
}
.el-dialog__body {
  padding: 0.78rem;
}
.wrapLimit {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  > div {
    margin-top: 0.3rem;
    display: flex;
    flex: 0 0 50%;
    align-items: center;
    > span {
      width: 0.8rem;
      text-align: right;
      font-size: 0.16rem;
      color: #bbd4e9;
    }
  }
  > div:first-child {
    margin-top: 0.2rem;
  }
  .el-input {
    width: 2.48rem !important;
  }
  .el-input__inner {
    width: 2.48rem !important;
    border: 1px solid #0077ff;
    color: #fff;
    background: #203051;
  }
  .el-input__icon {
    height: 100%;
    width: 0.36rem;
    text-align: center;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    line-height: 0.4rem;
  }
}

.operation {
  display: flex;
  justify-content: center;
  margin-top: 0.4rem;
  span {
    width: 1.2rem;
    border: 1px solid #0077ff;
    border-radius: 4px;
    line-height: 0.4rem;
    text-align: center;
    font-size: 0.16rem;
    color: #bbd4e9;
    cursor: pointer;
    &:nth-child(2) {
      margin-left: 0.4rem;
      color: #fff;
      background: #3091ff;
    }
  }
}
</style>
